(() => {
  const colorMap = {
    blue: { label: 'Blue', hex: '#66c9f4' },
    pink: { label: 'Pink', hex: '#ff78b7' },
    purple: { label: 'Purple', hex: '#a86be8' },
    orange: { label: 'Orange', hex: '#ff8a2a' },
    teal: { label: 'Teal', hex: '#61d6c6' },
    green: { label: 'Green', hex: '#7ee06a' },
    yellow: { label: 'Yellow', hex: '#ffe95f' },
    red: { label: 'Red', hex: '#ff4f57' },
    white: { label: 'White', hex: '#f8f4ec' },
    black: { label: 'Black', hex: '#111111' },
    chocolate: { label: 'Chocolate', hex: '#8b4d2d' },
    choc: { label: 'Chocolate', hex: '#8b4d2d' }
  };

  const colorForLabel = (label = '') => {
    const normalized = label.toLowerCase();
    const matches = Object.entries(colorMap)
      .filter(([key]) => normalized.includes(key))
      .map(([, value]) => value);

    if (!matches.length && normalized.includes('lime green')) return colorMap.green.hex;
    if (matches.length < 2) return matches[0]?.hex || '#8fd7ff';

    return `linear-gradient(135deg, ${matches[0].hex} 0 50%, ${matches[1].hex} 50% 100%)`;
  };

  const cssEscape = (value = '') => {
    if (window.CSS?.escape) return window.CSS.escape(value);
    return String(value).replace(/["\\]/g, '\\$&');
  };

  const productHandle = () => {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const noSwatchHandles = new Set([
    'blue-nice-cube-size-set',
    'viral-starter-pack',
    'ultimate-collector-bundle',
    'texture-pack',
    'nice-cube-family-pack',
    'cute-character-pack',
    'needoh-advent-calendar',
    'needoh-cool-cane',
    'needoh-ginger-glowman',
    'needoh-nice-berg',
    'needoh-press-doh',
    'needoh-rainboh',
    'needoh-squish-n-flow-snow-globe',
    'snow-ball-crunch',
    'teenie-needoh'
  ]);

  const normalizeLabel = (label = '') => label.trim().toLowerCase().replace(/\s+and\s+/g, ' / ').replace(/\s*\/\s*/g, ' / ');

  const variantInputForLabel = (sectionId, label) => {
    const variantSelects =
      document.getElementById(`variant-selects-${sectionId}`) ||
      document.querySelector(`variant-selects[data-section="${cssEscape(sectionId)}"]`);

    return [...(variantSelects?.querySelectorAll('input[type="radio"]') || [])].find(
      (input) => normalizeLabel(input.value) === normalizeLabel(label)
    );
  };

  const syntheticAssetMap = {
    'atomic-needoh': {
      blue: 'atomic-needoh-blue-clean-20260517.png'
    },
    'happy-snappy': {
      pink: 'happy-snappy-pink-generated.png',
      purple: 'happy-snappy-purple-generated.png'
    },
    'jelly-dohnut-needoh': {
      pink: 'jelly-dohnut-needoh-pink-generated.png'
    },
    needoh: {
      orange: 'needoh-orange-generated.png'
    },
    'needoh-bunnies-and-chicks-assortment': {
      'blue bunny': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/BCNDA25_Image3.jpg?v=1787000369',
      'pink bunny': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/BCNDA25_Image1.jpg?v=1787000369',
      'yellow chick': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/BCNDA25_Image4.jpg?v=1787000368'
    },
    'needoh-color-change-squeeze-heart': {
      'pink / purple': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/CCSQHND25_Image3_620be392-02f1-4acf-9c5c-d73eabb732fd.jpg?v=1787000371',
      'blue / green': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/CCSQHND25_Image4_f5b04dca-1b26-44b5-93bc-cfac75abe607.jpg?v=1787000370',
      'purple / orange': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/CCSQHND25_Image5_235410ca-d2bd-42f9-99d9-bb3a87db80d8.jpg?v=1787000370'
    },
    'needoh-dohnut-holes': {
      sprinkles: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/DHTND_Image1.jpg?v=1787000370',
      'powdered sugar': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/DHTND_Image3.jpg?v=1787000371',
      'cakey texture': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/DHTND_Image4.jpg?v=1787000371'
    },
    'needoh-dohnuts': {
      'pink / blue sprinkles': 'needoh-dohnuts-pink-blue-official.jpg',
      'pink / blue sugar': 'needoh-dohnuts-pink-blue-official.jpg',
      'pink / blue swirl': 'needoh-dohnuts-pink-blue-official.jpg',
      'orange / pink sprinkles': 'needoh-dohnuts-orange-pink-official.jpg',
      'orange / pink sugar': 'needoh-dohnuts-orange-pink-official.jpg',
      'orange / pink swirl': 'needoh-dohnuts-orange-pink-official.jpg',
      'yellow / purple sprinkles': 'needoh-dohnuts-yellow-purple-official.jpg',
      'yellow / purple sugar': 'needoh-dohnuts-yellow-purple-official.jpg',
      'yellow / purple swirl': 'needoh-dohnuts-yellow-purple-official.jpg'
    },
    'needoh-fuzz-ball-flower-power': {
      purple: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/FPFZBND__12-1536x1426.png?v=1787000371',
      orange: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/FPFZBND__5.jpg?v=1787000371',
      blue: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/FPFZBND__2.jpg?v=1787000372',
      green: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/FPFZBND__3.jpg?v=1787000372',
      pink: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/FPFZBND__6.jpg?v=1787000372'
    },
    'needoh-fuzz-ball-wonder-waves': {
      orange: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/WWFZBND__8.jpg?v=1787000373',
      blue: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/WWFZBND__5.jpg?v=1787000374',
      pink: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/WWFZBND__9.jpg?v=1787000374',
      purple: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/WWFZBND__10.jpg?v=1787000373',
      green: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/WWFZBND__6.jpg?v=1787000374'
    },
    'needoh-groovy-shroom': {
      'orange / purple': 'needoh-groovy-shroom-orange-purple-generated.png',
      'blue / pink': 'needoh-groovy-shroom-blue-pink-generated.png'
    },
    'needoh-gumdrop': {
      blue: 'needoh-gumdrop-blue-clean-20260517.png'
    },
    'needoh-gummy-bear': {
      blue: 'needoh-gummy-bear-blue-generated.png',
      orange: 'needoh-gummy-bear-orange-generated.png',
      purple: 'needoh-gummy-bear-purple-generated.png'
    },
    'needoh-mello-mallo': {
      'pink / red': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/MMND__3_cd1f5ea0-1e78-40a4-80b0-7521d57a7547.jpg?v=1787000378',
      'yellow / orange': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/MMND__6.jpg?v=1787000378',
      'blue / purple': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/MMND__4_308dc6f6-2556-4a4c-91cd-a33158be6d24.jpg?v=1787000378'
    },
    'needoh-nice-cube': {
      pink: 'needoh-nice-cube-pink-generated.png'
    },
    'needoh-nice-cube-swirl': {
      'green / blue': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SWNCBND__4-1536x1536.jpg?v=1787000379',
      'orange / yellow': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SWNCBND__7.jpg?v=1787000379',
      'pink / purple': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SWNCBND__5.jpg?v=1787000380'
    },
    'needoh-nice-ice-baby': {
      blue: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNCBND__2.jpg?v=1787000380',
      pink: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNCBND__3.jpg?v=1787000380',
      purple: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNCBND__4.jpg?v=1787000380'
    },
    'needoh-panic-pete': {
      orange: 'needoh-panic-pete-colour-group-clean-20260518.jpg',
      pink: 'needoh-panic-pete-pink-clean-20260518.jpg'
    },
    'needoh-polar-glow-penguin': {
      'pink / purple': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SQMPND25__4.jpg?v=1787000383',
      'green / pink': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SQMPND25__3.jpg?v=1787000383'
    },
    'needoh-splootsplat': {
      purple: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SPLND__3-1536x1536.jpg?v=1787000384',
      blue: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SPLND__4.jpg?v=1787000384',
      green: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SPLND__2.jpg?v=1787000385'
    },
    'needoh-squeezter-egg': {
      'blue bunny': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SQTEND25_Image3.jpg?v=1787000392',
      'yellow chick': 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/SQTEND25_Image5.jpg?v=1787000392'
    },
    'needoh-teenie-singles': {
      blue: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNDA_Image1-1536x1536.jpg?v=1787000387',
      green: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNDA_Image1-1536x1536.jpg?v=1787000387',
      orange: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNDA_Image1-1536x1536.jpg?v=1787000387',
      pink: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNDA_Image1-1536x1536.jpg?v=1787000387',
      purple: 'https://cdn.shopify.com/s/files/1/0978/7215/0856/files/TSNDA_Image3.jpg?v=1787000389'
    },
    'shaggy-needoh': {
      purple: 'shaggy-needoh-purple-generated.png',
      teal: 'shaggy-needoh-teal-generated.png'
    },
    'super-needoh-cool-cats': {
      blue: 'super-needoh-cool-cats-blue-generated.png',
      orange: 'super-needoh-cool-cats-orange-generated.png'
    },
    'teenie-needoh-funky-pup': {
      orange: 'teenie-needoh-funky-pup-colour-group-clean-20260518.jpg',
      pink: 'teenie-needoh-funky-pup-colour-group-clean-20260518.jpg'
    }
  };

  const styleHandles = new Set(['needoh-dohnuts', 'needoh-dohnut-holes', 'needoh-squeezter-egg']);

  const canonicalChoicesByHandle = {
    'needoh-dohnuts': [
      { label: 'Pink / Blue Sprinkles', src: 'needoh-dohnuts-pink-blue-official.jpg' },
      { label: 'Pink / Blue Sugar', src: 'needoh-dohnuts-pink-blue-official.jpg' },
      { label: 'Pink / Blue Swirl', src: 'needoh-dohnuts-pink-blue-official.jpg' },
      { label: 'Orange / Pink Sprinkles', src: 'needoh-dohnuts-orange-pink-official.jpg' },
      { label: 'Orange / Pink Sugar', src: 'needoh-dohnuts-orange-pink-official.jpg' },
      { label: 'Orange / Pink Swirl', src: 'needoh-dohnuts-orange-pink-official.jpg' },
      { label: 'Yellow / Purple Sprinkles', src: 'needoh-dohnuts-yellow-purple-official.jpg' },
      { label: 'Yellow / Purple Sugar', src: 'needoh-dohnuts-yellow-purple-official.jpg' },
      { label: 'Yellow / Purple Swirl', src: 'needoh-dohnuts-yellow-purple-official.jpg' }
    ]
  };

  const assetBase = () => {
    const script =
      document.currentScript ||
      [...document.scripts].find((item) => item.src.includes('needoh-product-colour-selector'));
    const src = script?.src || '';
    return src.includes('/assets/') ? src.split('/assets/')[0] + '/assets/' : '/';
  };

  const syntheticSwatch = (button) => {
    const explicitSrc = button?.dataset.ndSwatchSrc;
    if (explicitSrc) {
      return {
        src: explicitSrc,
        alt: button.dataset.ndSwatchAlt || button.dataset.ndSwatchLabel || ''
      };
    }

    const handle = productHandle();
    const label = normalizeLabel(button?.dataset.ndSwatchLabel || '');
    const filename = syntheticAssetMap[handle]?.[label];
    if (filename) {
      const isAbsolute = /^https?:\/\//.test(filename) || filename.startsWith('//') || filename.startsWith('/');
      return {
        src: isAbsolute ? filename : `${assetBase()}${filename}`,
        alt: button?.dataset.ndSwatchLabel ? `NeeDoh ${button.dataset.ndSwatchLabel}` : ''
      };
    }

    return { src: '', alt: '' };
  };

  const storeOriginalImage = (image) => {
    if (!image || image.dataset.ndOriginalSrc) return;
    image.dataset.ndOriginalSrc = image.getAttribute('src') || '';
    image.dataset.ndOriginalSrcset = image.getAttribute('srcset') || '';
    image.dataset.ndOriginalSizes = image.getAttribute('sizes') || '';
    image.dataset.ndOriginalAlt = image.getAttribute('alt') || '';
  };

  const restoreSyntheticImages = (mediaGallery) => {
    mediaGallery?.querySelectorAll('[data-nd-synthetic-applied="true"]').forEach((image) => {
      if (image.dataset.ndOriginalSrc) image.setAttribute('src', image.dataset.ndOriginalSrc);
      if (image.dataset.ndOriginalSrcset) image.setAttribute('srcset', image.dataset.ndOriginalSrcset);
      else image.removeAttribute('srcset');
      if (image.dataset.ndOriginalSizes) image.setAttribute('sizes', image.dataset.ndOriginalSizes);
      else image.removeAttribute('sizes');
      image.setAttribute('alt', image.dataset.ndOriginalAlt || '');
      delete image.dataset.ndSyntheticApplied;
    });
  };

  const applyImageTo = (image, source) => {
    if (!image || !source?.src) return;
    storeOriginalImage(image);
    image.setAttribute('src', source.src);
    if (source.srcset) image.setAttribute('srcset', source.srcset);
    else image.removeAttribute('srcset');
    if (source.sizes) image.setAttribute('sizes', source.sizes);
    else image.removeAttribute('sizes');
    image.setAttribute('alt', source.alt || '');
    image.dataset.ndSyntheticApplied = 'true';
  };

  const sourceFromImage = (image) => {
    if (!image) return null;
    return {
      src: image.getAttribute('src') || '',
      srcset: image.getAttribute('srcset') || '',
      sizes: image.getAttribute('sizes') || '',
      alt: image.getAttribute('alt') || ''
    };
  };

  const applySwatchImage = (button, mediaGallery) => {
    const synthetic = syntheticSwatch(button);
    const mediaId = button.dataset.ndMediaId || '';
    const mediaScope = mediaId
      ? mediaGallery?.querySelector(`[data-media-id="${cssEscape(mediaId)}"]`)
      : null;
    const mediaImage = mediaScope?.querySelector('.product__media img, img');
    const primaryImage = mediaGallery?.querySelector('.product__media img');
    const thumbnailImage = mediaId
      ? mediaGallery?.querySelector(`[data-target="${cssEscape(mediaId)}"] img`)
      : null;
    const swatchSource = synthetic.src
      ? {
          src: synthetic.src,
          srcset: '',
          sizes: '',
          alt: synthetic.alt || button.dataset.ndSwatchLabel || ''
        }
      : sourceFromImage(mediaImage);

    if (!swatchSource?.src) return;

    [primaryImage, mediaImage, thumbnailImage].forEach((image, index, images) => {
      if (!image || images.indexOf(image) !== index) return;
      applyImageTo(image, swatchSource);
    });
  };

  const absoluteAsset = (value = '') => {
    if (!value) return '';
    return /^https?:\/\//.test(value) || value.startsWith('//') || value.startsWith('/')
      ? value
      : `${assetBase()}${value}`;
  };

  const buttonMarkup = (choice, index) => `
    <button
      type="button"
      class="nd-media-swatch${index === 0 ? ' is-active' : ''}"
      data-nd-media-id="${choice.mediaId || ''}"
      data-nd-swatch-label="${choice.label}"
      ${choice.src ? `data-nd-swatch-src="${absoluteAsset(choice.src)}"` : ''}
      ${choice.alt ? `data-nd-swatch-alt="${choice.alt}"` : ''}
      aria-label="Show ${choice.label}"
      aria-pressed="${index === 0 ? 'true' : 'false'}"
    >
      <span class="nd-media-swatch__color" style="--nd-swatch-color: ${choice.hex};"></span>
      <span class="visually-hidden">${choice.label}</span>
    </button>
  `;

  const hydrateCanonicalChoices = (swatches) => {
    const choices = canonicalChoicesByHandle[productHandle()];
    if (!choices?.length) return false;

    const rail = swatches.querySelector('.nd-media-swatches__rail');
    if (!rail) return false;

    const existingLabels = [...swatches.querySelectorAll('[data-nd-swatch-label]')]
      .map((button) => button.dataset.ndSwatchLabel || '')
      .join('|');
    const canonicalLabels = choices.map((choice) => choice.label).join('|');
    if (existingLabels === canonicalLabels) return false;

    const enrichedChoices = choices.map((choice) => ({
      ...choice,
      hex: choice.hex || colorForLabel(choice.label),
      alt: choice.alt || `NeeDoh ${choice.label}`
    }));

    rail.innerHTML = enrichedChoices.map(buttonMarkup).join('');

    const labelNode = swatches.querySelector('.nd-media-swatches__label');
    const selectedLabel = swatches.querySelector('[data-nd-swatch-selected]');
    if (labelNode) labelNode.textContent = styleHandles.has(productHandle()) ? 'Choose your style' : 'Choose your colour';
    if (selectedLabel) selectedLabel.textContent = enrichedChoices[0].label;

    let property = swatches.querySelector('[data-nd-swatch-property]');
    if (!property) {
      const form = document.querySelector('form[action*="/cart/add"]');
      property = document.createElement('input');
      property.type = 'hidden';
      property.dataset.ndSwatchProperty = 'true';
      if (form) form.appendChild(property);
      else swatches.appendChild(property);
    }
    property.name = styleHandles.has(productHandle()) ? 'properties[Style]' : 'properties[Colour]';
    property.value = enrichedChoices[0].label;
    delete swatches.dataset.ndReady;
    return true;
  };

  const sanitizeLegacySwatches = (root = document) => {
    root.querySelectorAll('.nd-media-swatches').forEach((swatches) => {
      if (hydrateCanonicalChoices(swatches)) return;

      if (swatches.querySelector('.nd-media-swatch__color')) return;

      const existingButtons = [...swatches.querySelectorAll('[data-nd-media-id]')];
      if (!existingButtons.length) return;

      const choices = [];
      const seen = new Set();

      existingButtons.forEach((button) => {
        const label = (button.dataset.ndSwatchLabel || button.getAttribute('aria-label') || '').replace(/^show\s+/i, '').trim();
        if (!label || seen.has(label)) return;
        seen.add(label);
        choices.push({
          label,
          hex: colorForLabel(label),
          mediaId: button.dataset.ndMediaId
        });
      });

      if (choices.length < 2) return;

      const labelNode = swatches.querySelector('.nd-media-swatches__label');
      const selectedLabel = swatches.querySelector('[data-nd-swatch-selected]');
      const rail = swatches.querySelector('.nd-media-swatches__rail');
      if (!rail) return;

      if (labelNode) labelNode.textContent = styleHandles.has(productHandle()) ? 'Choose your style' : 'Choose your colour';
      if (selectedLabel) selectedLabel.textContent = choices[0].label;

      rail.innerHTML = choices.map(buttonMarkup).join('');

      let property = swatches.querySelector('[data-nd-swatch-property]');
      if (!property) {
        const form = document.querySelector('form[action*="/cart/add"]');
        property = document.createElement('input');
        property.type = 'hidden';
        property.dataset.ndSwatchProperty = 'true';
        if (form) form.appendChild(property);
        else swatches.appendChild(property);
      }
      property.name = styleHandles.has(productHandle()) ? 'properties[Style]' : 'properties[Colour]';
      property.value = choices[0].label;
    });
  };

  const initSwatches = (root = document) => {
    if (noSwatchHandles.has(productHandle())) {
      root.querySelectorAll('.nd-media-swatches').forEach((swatches) => swatches.remove());
      root.querySelectorAll('[data-nd-swatch-property]').forEach((property) => property.remove());
      return;
    }

    sanitizeLegacySwatches(root);

    root.querySelectorAll('.nd-media-swatches:not([data-nd-ready])').forEach((swatches) => {
      swatches.dataset.ndReady = 'true';
      const sectionId = swatches.dataset.sectionId;
      const mediaGallery = document.getElementById(`MediaGallery-${sectionId}`);
      const selectedLabel = swatches.querySelector('[data-nd-swatch-selected]');
      const selectedProperty = swatches.querySelector('[data-nd-swatch-property]');
      const buttons = [...swatches.querySelectorAll('[data-nd-media-id]')];

      const setActive = (mediaId, labelFromEvent) => {
        const activeButton = labelFromEvent
          ? buttons.find((button) => button.dataset.ndSwatchLabel === labelFromEvent)
          : buttons.find((button) => button.dataset.ndMediaId === mediaId);
        if (!activeButton) return null;

        buttons.forEach((button) => {
          const isActive = button === activeButton;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        const label = activeButton.dataset.ndSwatchLabel || '';
        if (selectedLabel) selectedLabel.textContent = label;
        if (selectedProperty) {
          selectedProperty.value = label;
          selectedProperty.disabled = Boolean(variantInputForLabel(sectionId, label));
        }
        return activeButton;
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const mediaId = button.dataset.ndMediaId;
          restoreSyntheticImages(mediaGallery);
          const activeButton = setActive(mediaId, button.dataset.ndSwatchLabel);
          const variantInput = variantInputForLabel(sectionId, button.dataset.ndSwatchLabel);
          if (variantInput && !variantInput.checked) variantInput.click();
          if (mediaId) mediaGallery?.setActiveMedia?.(mediaId, false);
          requestAnimationFrame(() => {
            applySwatchImage(activeButton, mediaGallery);
          });
        });
      });

      const thumbnails = mediaGallery?.querySelector('[id^="GalleryThumbnails"]');
      thumbnails?.addEventListener('click', (event) => {
        const item = event.target.closest('[data-target]');
        if (item?.dataset.target) {
          restoreSyntheticImages(mediaGallery);
          const activeButton = setActive(item.dataset.target);
          requestAnimationFrame(() => {
            applySwatchImage(activeButton, mediaGallery);
          });
        }
      });

      mediaGallery?.querySelector('[id^="GalleryViewer"]')?.addEventListener('slideChanged', (event) => {
        const mediaId = event.detail?.currentElement?.dataset?.mediaId;
        if (mediaId) {
          restoreSyntheticImages(mediaGallery);
          const activeButton = setActive(mediaId);
          requestAnimationFrame(() => {
            applySwatchImage(activeButton, mediaGallery);
          });
        }
      });

      const currentThumbnail = thumbnails?.querySelector('[aria-current="true"]')?.closest('[data-target]');
      let activeButton = null;
      const checkedVariant = document.querySelector(`#variant-selects-${cssEscape(sectionId)} input[type="radio"]:checked`);
      const checkedVariantButton = checkedVariant
        ? buttons.find(
            (button) => normalizeLabel(button.dataset.ndSwatchLabel) === normalizeLabel(checkedVariant.value)
          )
        : null;
      if (checkedVariantButton) {
        activeButton = setActive(checkedVariantButton.dataset.ndMediaId, checkedVariantButton.dataset.ndSwatchLabel);
        if (checkedVariantButton.dataset.ndMediaId) {
          mediaGallery?.setActiveMedia?.(checkedVariantButton.dataset.ndMediaId, false);
        }
        applySwatchImage(activeButton, mediaGallery);
      } else if (currentThumbnail?.dataset.target) {
        activeButton = setActive(currentThumbnail.dataset.target);
        applySwatchImage(activeButton, mediaGallery);
      }
      if (!activeButton && buttons[0]) {
        activeButton = setActive(buttons[0].dataset.ndMediaId, buttons[0].dataset.ndSwatchLabel);
        if (buttons[0].dataset.ndMediaId) mediaGallery?.setActiveMedia?.(buttons[0].dataset.ndMediaId, false);
        applySwatchImage(activeButton, mediaGallery);
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => initSwatches());
  document.addEventListener('shopify:section:load', (event) => initSwatches(event.target));
})();
